import type { FC } from 'react'

import styled from '@emotion/styled'

import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EmailForm, { SuccessMessage } from '../../../components/EmailForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `Analytics Academy `,
  heading: `The right place to learn analytics`,
  description: `Learn from top industry experts and level-up your analytics knowledge through these six free courses, with 38 lessons that include real-life examples and data.`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroRecipeBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p">{copy.description}</CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <EmailForm id="hero-email-capture-form" compact={true} success={<SuccessMessage align="left" />} />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage />
        </HeroRecipe.Contents>
      </HeroRecipeBase>
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`
